// Track geometry shared by every module. World units are metres.
// The track runs along +X: start line at x = 0, finish at x = TRACK_LENGTH.
// Lane 0 is nearest the grandstand (smallest z).

export const TRACK_LENGTH = 600;
export const LANE_WIDTH = 2.4;
export const LANE_COUNT = 6;

/** z of a lane's centre line. Lanes are centred around z = 0. */
export function laneCenterZ(lane: number): number {
  return (lane - (LANE_COUNT - 1) / 2) * LANE_WIDTH;
}

/** x along the track for a 0..1 race position. */
export function posToX(pos: number): number {
  return pos * TRACK_LENGTH;
}

/** World position of a lane and race position (y = 0 on the turf). */
export function trackToWorld(lane: number, pos: number): { x: number; y: number; z: number } {
  return { x: posToX(pos), y: 0, z: laneCenterZ(lane) };
}
